$(document).ready(function() {
	// $('.js-ratingStars').length && $('.js-ratingStars').rating({
	// 	hoverOnClear: false,
	// 	theme: 'krajee-fa'
	// });

	section();
	// setVersion();

	// NAVIGATION TRIGGER
	$('.js-navOpen').on('click', function() {
		$('body').addClass('nav-opened');
		$('.js-nav').addClass('opened');
		stop();
	});

	$('.js-sliderBannerPageSlider').length && $('.js-sliderBannerPageSlider').slick({
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 5000,
		fade: true
	});

	$('.js-sliderNewsIndex').length && $('.js-sliderNewsIndex').slick({
		slidesToShow: 1,
		speed: 800,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: 500,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3
				}
			}
		]
	});
	
	$('.js-sliderRoadmap').length && $('.js-sliderRoadmap').slick({
		slidesToShow: 1,
		speed: 800,
		infinite: false,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: 500,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4
				}
			}
		]
	});
	
	$('.js-sliderProjectImplemented').length && $('.js-sliderProjectImplemented').slick({
		slidesToShow: 2,
		speed: 800,
		infinite: false,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4
				}
			}
		]
	});

	if ($('.js-sliderSyncLarge').length && $('.js-sliderSyncThumb').length) {
		$('.js-sliderSyncLarge').not(".slick-initialized").slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 800,
			infinite: false,
			arrows: false,
			fade: true,
			asNavFor: '.js-sliderSyncThumb'
		}).on("afterChange", (function (e, a, currentSlide ) {
			var o,
				s;
			$(".bumper").css("display", "block"),
			o = $(currentSlide).eq(e).data("youtubeplayer"),
			s = "pause",
			o && !0 === o._donecheck && ("play" == s ? o.playVideo() : "pause" == s && o.pauseVideo());
		}));
		$('.js-sliderSyncThumb').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			speed: 800,
			infinite: false,
			asNavFor: '.js-sliderSyncLarge',
			dots: false,
			focusOnSelect: true,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 3
					}
				}
			]
		});
		$(".js-sliderSyncLarge").on("beforeChange", (function (e, a, t, o) {
			var s = $(a.$slides[t]);
			s.html(s.html())
		}));
	}

	// $('.js-ytCtrl').on('click', function() {
	// 	let parent = $(this).closest('.item'),
	// 		iframe = parent.find('iframe'),
	// 		src = iframe.attr('src');

	// 	src += '?autoplay=1';
	// 	iframe.attr('src', src);
	// 	$(this).fadeOut(300);
	// });

	$(".js-typing").each(function(){
		var $this = $(this);
		$this.typed({
			strings: $this.attr('data-value').split(';'),
			typeSpeed: 100, // typing speed
			backDelay: 1800, // pause before backspacing,
			backSpeed: 10
		});
	});

	$('.js-loadMoreSolution').on('click', function() {
		let parent = $(this).closest('section');
		parent.addClass("showMore");
		$(this).fadeOut(300);
	});

	$('.js-tabLogin').on('click', function() {
		let target = $(this).data('target'),
			parent = $(this).closest('.inner'),
			parent2 = $(this).closest('.content');

		parent.removeClass('actived');
		$(target).addClass('actived');
		parent2.scrollTop(0);
	});

	$('.js-progressBtn').on('click', function() {
		let target = $('.js-progressBar .step'),
			value = parseFloat(target.data('value'));

		value += 33.333;
		target.css('left', value+'%').data('value', value);
	});

	if ($('.js-discountSlider').length) {
		let $this = $(this),
			discountFirst = $this.find('.js-discountFirst'),
			contract = $this.find('.js-contract');

		$('.js-discountSlider').slider({
			range: "min",
			min: 0,
			max: 150,
			value: 30,
			slide: function(event, ui) {
				let discount = 0;

				if (ui.value >= 2 && ui.value < 30) {
					discount = 15
				}
				if (ui.value >= 30 && ui.value < 50) {
					discount = 20
				}
				if (ui.value >= 50 && ui.value < 100) {
					discount = 25
				}
				if (ui.value >= 100 && ui.value < 150) {
					discount = 30
				}
				if (ui.value >= 150) {
					discount = 40
				}
				
				contract.text(ui.value);
				discountFirst.text(discount);
			}
		});
	}

	$('.js-smoothScroll').on('click', function() {
		smoothScroll($(this), $('.header'));
	});

	$('.js-deviceTrigger').on('click', function() {
		let type = $(this).data('type'),
			target = $('.js-device');
		
		$(this).siblings().removeClass('active');
		$(this).addClass('active');
		target.attr('type', type);
	});

	$('.js-removeBar').on('click', function() {
		$(this).closest('.theme-demo__top').remove();
	});

	// TAB NAVIGATION
	$('.js-tabLink').on('click', function() {
		var target = $(this).data('target'),
			parent = $(this).closest('.js-tabParent');

		parent.find('.js-tabNav .js-tabLink').removeClass('active');
		parent.find('.js-tabContent .tab-panel').removeClass('active');
		$(target).addClass('active');
		$(this).addClass('active');
		$('.login-section .content').scrollTop(0);
	});
});
